import Phaser from "phaser";
import { GAME_WIDTH, GAME_HEIGHT } from "../config";
import { PurchaseGate } from "../systems/PurchaseGate";

interface GameOverData {
  score: number;
  maxComboMult: number;
}

/** ゲームオーバーシーン */
export class GameOverScene extends Phaser.Scene {
  private data_score = 0;
  private data_maxComboMult = 1.0;

  constructor() {
    super({ key: "GameOverScene" });
  }

  init(data: GameOverData): void {
    this.data_score = data.score ?? 0;
    this.data_maxComboMult = data.maxComboMult ?? 1.0;
  }

  create(): void {
    this.cameras.main.setBackgroundColor("#110011");

    // GAME OVER
    const title = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT * 0.2, "GAME OVER", {
      fontSize: "36px",
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#ff4444",
      fontStyle: "bold",
    });
    title.setOrigin(0.5, 0.5);

    // スコア
    const scoreText = this.add.text(
      GAME_WIDTH / 2,
      GAME_HEIGHT * 0.35,
      `SCORE: ${this.data_score}`,
      {
        fontSize: "28px",
        fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
        color: "#ffffff",
      }
    );
    scoreText.setOrigin(0.5, 0.5);

    // 最大コンボ倍率
    const comboText = this.add.text(
      GAME_WIDTH / 2,
      GAME_HEIGHT * 0.43,
      `MAX COMBO: x${this.data_maxComboMult.toFixed(1)}`,
      {
        fontSize: "20px",
        fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
        color: "#ffdd44",
      }
    );
    comboText.setOrigin(0.5, 0.5);

    // Retryボタン
    const retryBtn = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT * 0.58, "RETRY", {
      fontSize: "24px",
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#ffffff",
      backgroundColor: "#333333",
      padding: { x: 36, y: 12 },
    });
    retryBtn.setOrigin(0.5, 0.5);
    retryBtn.setInteractive({ useHandCursor: true });
    retryBtn.on("pointerover", () => retryBtn.setColor("#00ffcc"));
    retryBtn.on("pointerout", () => retryBtn.setColor("#ffffff"));
    retryBtn.on("pointerdown", () => {
      this.scene.start("PlayScene");
    });

    // 長文モード解放ボタン（任意）
    const gate = new PurchaseGate();
    if (gate.getFlag() === "FREE") {
      const unlockBtn = this.add.text(
        GAME_WIDTH / 2,
        GAME_HEIGHT * 0.72,
        "もっと難しくする（長文モード）",
        {
          fontSize: "16px",
          fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
          color: "#ffdd44",
          backgroundColor: "#222222",
          padding: { x: 20, y: 10 },
        }
      );
      unlockBtn.setOrigin(0.5, 0.5);
      unlockBtn.setInteractive({ useHandCursor: true });
      unlockBtn.on("pointerover", () => unlockBtn.setColor("#ffffff"));
      unlockBtn.on("pointerout", () => unlockBtn.setColor("#ffdd44"));
      unlockBtn.on("pointerdown", () => {
        gate.unlockLongMode();
        unlockBtn.setText("解放済！");
        unlockBtn.disableInteractive();
      });
    } else {
      const badge = this.add.text(
        GAME_WIDTH / 2,
        GAME_HEIGHT * 0.72,
        "長文モード解放済",
        {
          fontSize: "14px",
          fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
          color: "#ffdd44",
        }
      );
      badge.setOrigin(0.5, 0.5);
    }

    // Shareボタン（ダミー）
    const shareBtn = this.add.text(GAME_WIDTH / 2, GAME_HEIGHT * 0.84, "SHARE", {
      fontSize: "18px",
      fontFamily: "'Hiragino Kaku Gothic Pro', 'Meiryo', sans-serif",
      color: "#aaaaaa",
      backgroundColor: "#222222",
      padding: { x: 24, y: 8 },
    });
    shareBtn.setOrigin(0.5, 0.5);
    shareBtn.setInteractive({ useHandCursor: true });
    shareBtn.on("pointerdown", () => {
      console.log(
        `[Share] Text Invaders - Score: ${this.data_score}, Max Combo: x${this.data_maxComboMult.toFixed(1)}`
      );
      shareBtn.setText("Copied! (dummy)");
    });
  }
}
